import api from "api";
import { MENU } from "constants/accesos";
import { removeSession } from "hooks/useFilters";
import useQuery from "hooks/useQuery";
import { useState } from "react";
import { Link } from "react-router-dom";
import { capitalizeFirstLetter } from "utils";
import DynamicIcon from "./DynamicIcon";

const useSidebarMenuItems = () => {
  const [menuItems, setMenuItems] = useState([]);

  useQuery({
    queryFn: api.auth.getAccesos,
    onSuccess: (res) => {
      const parsedAccesos = res.data?.menu?.map((a) => {
        const children = a.menu_items.map((item) => ({
          key: item.orden,
          label: (
            <Link
              to={item.link}
              onClick={() => removeSession("pagination_filters")}
              state={{
                origen: item.accesos_id === MENU.CASA_CENTRAL.ACUERDOS
                  ? 'menuCasaCentral'
                  : item.accesos_id === MENU.AUTOMATICOS.CPBTES_PENDIENTES
                  ? 'menuRecibosAutomaticos'
                  : item.accesos_id === MENU.FONDOS.SALDO_PENDIENTE
                  ? 'menuSaldoPendiente'
                  : item.accesos_id === MENU.AUTOMATICOS.SALDO_PENDIENTE
                  ? 'menuRecibosAutomaticos'
                  : ''
              }}
            >
              {capitalizeFirstLetter(item.item)}
            </Link>
          ),
        }));

        const label = (a.link ?
          <Link to={a.link}>
            {capitalizeFirstLetter(a.menu)}
          </Link>
          : capitalizeFirstLetter(a.menu)
        );
        
        return {
          key: a.menu,
          label: label,
          children: children,
          icon: <DynamicIcon icon={a.icono} />
        }
      });

      setMenuItems(parsedAccesos);
    }
  });

  return {
    menuItems,
  }
}

export default useSidebarMenuItems
